var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"label":"Itinerary","items":_vm.items,"item-text":"reference","item-value":"id","dense":"","outlined":_vm.$store.getters.localSettings('outlinedInputs'),"autocomplete":""},on:{"change":_vm.onChange},model:{value:(_vm.itinerary),callback:function ($$v) {_vm.itinerary=$$v},expression:"itinerary"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cdfabf9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/admin/documents/ItineraryListSelect.vue
// module id = null
// module chunks = 